"use client";

import "./AttemptBadge.css";

function getAttemptConfig(attemptNo) {
  if (attemptNo <= 2) return { variant: "ok", label: `Attempt ${attemptNo}` };
  if (attemptNo <= 4) return { variant: "warn", label: `Attempt ${attemptNo}` };
  return { variant: "danger", label: `Attempt ${attemptNo}` };
}

export default function AttemptBadge({ attemptNo = 1 }) {
  const { variant, label } = getAttemptConfig(attemptNo);

  return (
    <div className="ab-card">
      <span className={`ab-badge ab-badge--${variant}`}>
        <span className="ab-dot" />
        {label}
      </span>
    </div>
  );
}
